import React, { createContext, useContext, useMemo } from "react";
import { useGeneralContext } from "./GeneralContext";

const AnniversaryCampaignContext = createContext();

const AnniversaryCampaignContextProvider = ({ children }) => {
  const { allCourses } = useGeneralContext();
  // PRODUCTION
  const coursesReleaseDate = [];

  const availableAnniversaryCoursesIds = coursesReleaseDate
    .filter((course) => course.date < new Date())
    .map((course) => course.id);

  const anniversaryCourses = useMemo(() => {
    return Array.from(
      new Set(
        allCourses
          .filter((course) =>
            coursesReleaseDate.map((course) => course.id).includes(course.id)
          )
          .map((course) => course.id)
      )
    )
      .map((id) => {
        return allCourses.find((course) => course.id === id);
      })
      .sort((a, b) => {
        const aDate = coursesReleaseDate.find(
          (course) => course.id === a.id
        ).date;
        const bDate = coursesReleaseDate.find(
          (course) => course.id === b.id
        ).date;

        return aDate - bDate;
      });
  }, [allCourses, coursesReleaseDate]);

  return (
    <AnniversaryCampaignContext.Provider
      value={{
        anniversaryCourses,
        availableCoursesIds: availableAnniversaryCoursesIds,
        coursesReleaseDate,
      }}
    >
      {children}
    </AnniversaryCampaignContext.Provider>
  );
};

const useAnniversaryCampaignContext = () => {
  const context = useContext(AnniversaryCampaignContext);

  return context;
};

export {
  AnniversaryCampaignContext,
  AnniversaryCampaignContextProvider,
  useAnniversaryCampaignContext,
};
